/** `target('queue.header')` → `[data-tour="queue.header"]`. */
export const target = (id: string) => `[data-tour="${id}"]`
